import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Icon from '@material-ui/core/Icon';

import { updateSessionName } from '../../../store/actions/session.actions';
import { addMessage } from '../../../store/actions/message.actions';

const styles = theme => ({
  textField: {
    padding: '25px 25px 40px 25px',
  },
  icon: {
    marginRight: theme.spacing.unit,
  },
  buttonLeft: {
    float: 'left',
  },
  buttonRight: {
    float: 'right',
  },
});

class ChangeSessionName extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.updateName = this.updateName.bind(this);
    this.cancel = this.cancel.bind(this);

    this.state = {
      open: false,
      name: this.props.session.name,
    };
  }

  toggle(e) {

    this.setState({ open: !this.state.open });
  }

  handleChange(e) {

    this.setState({ name: e.target.value });

  }

  updateName(e) {
    e.preventDefault();


    const { name } = this.state;
    if (name.replace(/\s/g, '') === '') {
      this.props.addMessage('error', 'Project name can not be empty');
      return;
    }

    this.props.updateSessionName(this.props.session.id, name);
    this.props.addMessage('success', 'Project name is changed');
    this.props.callback();
  }

  cancel() {
    this.props.callback();
    this.toggle();
  }

  render() {
    const {
      classes,
    } = this.props;

    return (
      <React.Fragment>
        <Button
          onClick={this.toggle}
          color="primary"
        >
          <Icon className={classes.icon}>edit</Icon>
          Update name
        </Button>

        <Dialog
          open={this.state.open}
          onClose={this.toggle}
        >
          <DialogTitle>Change Project Name</DialogTitle>
          <DialogContent className={this.props.classes.dialog}>
            <form onSubmit={this.updateName}>
              <TextField
                autoFocus
                className={classes.textField}
                value={this.state.name}
                onChange={this.handleChange}
                fullWidth
              />
              <Button className={classes.buttonLeft} onClick={this.cancel} color="primary">
                Cancel
              </Button>
              <Button type="submit" className={classes.buttonRight} color="primary">
                Save
              </Button>
            </form>
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
}

ChangeSessionName.propTypes = {
  session: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  callback: PropTypes.func,
  updateSessionName: PropTypes.func.isRequired,
  addMessage: PropTypes.func.isRequired,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  /* eslint-enable */
};

ChangeSessionName.defaultProps = {
  callback: () => null,
};

export default withStyles(styles)(connect(
  null,
  { addMessage, updateSessionName },
)(ChangeSessionName));
